import { forwardRef } from 'react';
import { Segmented as AntdSegmented } from 'antd';

/**
 * @param {Object} props - Same shape as antd's own `Segmented` (already renders as a real
 *   `role="radiogroup"` of radio inputs), forwarded as-is. The track uses the theme's small border radius.
 */
const Segmented = forwardRef((props, ref) => <AntdSegmented ref={ref} {...props} />);
Segmented.displayName = 'Segmented';

export default Segmented;
